import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/password-recovery/types';

const initialState = Immutable.fromJS({
  isLoading: false,
  recoveryRequestHasBeenSentToEmail: undefined,
  recoveryRequesFailedReason: undefined
});

export default reducerCreator(initialState, {
  [types.PASSWORD_RECOVERY_SET_FORGOT_PASSWORD_LOADING]: (state, { isLoading }) =>
    state.set('isLoading', isLoading),

  [types.PASSWORD_RECOVERY_SET_RECOVERY_REQUEST_HAS_BEEN_SENT_TO_EMAIL]: (state, { recoveryRequestHasBeenSentToEmail }) =>
    state.set('recoveryRequestHasBeenSentToEmail', recoveryRequestHasBeenSentToEmail),

  [types.PASSWORD_RECOVERY_RESET_FORGOT_PASSWORD_STATE]: () =>
    initialState,
    
  [types.PASSWORD_RECOVERY_SET_RECOVERY_REQUEST_FAILED_REASON]: (state, { recoveryRequesFailedReason }) =>
     state.set('recoveryRequesFailedReason', recoveryRequesFailedReason),
});



// WEBPACK FOOTER //
// ./src/reducers/password-recovery/forgot-password.js